<template>
  <b-card no-body>
    <b-row class="mx-0" align-h="between" align-v="center">
      <b-col lg="4" md="12" sm="12">
        <h6>Related Flows</h6>
      </b-col>
    </b-row>
    <b-table
      id="threat-flows-table"
      class="table-with-actions-min-height px-2"
      responsive
      striped
      outlined
      :items="detailsFilter"
      :fields="tableFields"
      :per-page="perPage"
      :current-page="currentPage"
      @filtered="onFiltered"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #cell(@timestamp)="row">
        {{ formatDate(row.value) }}
      </template>
      <template #cell(totalBytes)="row">
        {{ formatBytes(row.value) }}
      </template>
      <template #cell(moreActions)="row">
        <b-dropdown
          v-if="showPcapDownloadOption(row.item.pcapFilename)"
          no-caret
          size="sm"
          variant="link"
          class="float-right"
        >
          <template #button-content>
            <b-icon icon="three-dots-vertical" font-scale="1.2" />
          </template>
          <ThreatPcapDownload
            :pcapFilename="row.item.pcapFilename"
            class="w-100"
          />
        </b-dropdown>
      </template>
    </b-table>

    <b-pagination
      v-if="getFilteredLength > perPage"
      v-model="currentPage"
      :total-rows="getFilteredLength"
      :per-page="perPage"
      align="right"
      first-number
      last-number
      prev-class="prev-item"
      next-class="next-item"
      class="my-2 mx-1"
    />
  </b-card>
</template>

<script>
import moment from 'moment';
import momentTimeFormat from '@/xvisor/constants/momentTimeFormat';
import readableBytes from '@/xvisor/utilities/readableBytes';
import ThreatPcapDownload from '@/xvisor/components/ThreatPcapDownload.vue';

export default {
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    ip: {
      type: String,
      required: true,
    },
    signatureId: {
      type: Number,
      required: true,
    },
  },
  components: {
    ThreatPcapDownload,
  },
  data() {
    return {
      xomeXpcap: {},
      isXomeXpcapLoaded: false,
      details: [],
      perPage: 5,
      currentPage: 1,
      filteredLength: 0,
      sortBy: '@timestamp',
      sortDesc: true,
      tableFields: [
        { key: '@timestamp', label: 'Time', sortable: true },
        { key: 'sourceIp', label: 'Source IP' },
        { key: 'sourcePort', label: 'Source Port' },
        { key: 'destinationIp', label: 'Destination IP' },
        { key: 'destinationPort', label: 'Destination Port' },
        { key: 'proto', label: 'Proto' },
        { key: 'totalBytes', label: 'Total Bytes', sortable: true },
        { key: 'totalPkts', label: 'Total Packets', sortable: true },
        { key: 'moreActions', label: '', sortable: false },
      ],
    };
  },
  computed: {
    detailsFilter() {
      return this.details.map((item) => ({
        ...item,
        totalBytes: item.numBytesClntToSrvr + item.numBytesSrvrToClnt,
        totalPkts: item.numPktsClntToSrvr + item.numPktsSrvrToClnt,
      }));
    },
    getFilteredLength() {
      return this.filteredLength;
    },
    url() {
      return `/alerts/${this.ip}/${this.signatureId}/logs.json`;
    },
    httpParams() {
      return { params: { start: this.start, end: this.end } };
    },
  },
  methods: {
    formatDate(dateStr) {
      return moment(dateStr).format(momentTimeFormat.dateTime);
    },
    formatBytes(bytes) {
      return readableBytes(bytes);
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
    httpGet() {
      this.$http
        .get(this.url, this.httpParams)
        .then((response) => {
          this.details = response.data;
          this.filteredLength = response.data.length;
        });
    },
    timeRange(timestamp) {
      const base = new Date(timestamp);
      return {
        start: new Date(base.getTime() - 60 * 60 * 1000),
        end: new Date(base.getTime() + 5 * 60 * 1000),
      };
    },
    showPcapDownloadOption(pcapFilename) {
      return !!pcapFilename;
    },
    // TODO: Switch to checking for suricata active on xome
    // getXomeXpcap() {
    //   this.isXomeXpcapLoaded = false;
    //   this.$http
    //     .get('settings/xomes/info.json')
    //     .then((response) => {
    //       response.data.forEach((xome) => { this.xomeXpcap[xome.id] = xome.xpcap; });
    //     })
    //     .finally(() => { this.isXomeXpcapLoaded = true; });
    // },
    // showPcapDownloadOption(xomeId) {
    //   const xpcapEnabledForXome = this.xomeXpcap[xomeId] ?? false;
    //   // Only show the download option if the time range is short enough and if xpcap is enabled for the XOME.
    //   return xpcapEnabledForXome;
    // },
  },
  mounted() {
    this.httpGet();
    this.getXomeXpcap();
  },
};
</script>
